import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { EditProfilRemisePage } from "@/features/ventes/components/tarifs/EditProfilRemisePage";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/remises/$id/edit")({
  loader: requirePermission(TARIF_PERMISSIONS.PROFILS_EDIT),
  staticData: {
    title: "Modifier profil de remise",
    showInBreadcrumb: true,
  },
  component: EditProfilRemisePage,
});
